import {
  DOCUMENT_STATUS_FILTER_OPTIONS,
  DOCUMENT_STATUS_LABELS,
  formatDocumentStatusLabel,
} from './documentStatus';

export const STOCK_RECEIPT_STATUS_LABELS = DOCUMENT_STATUS_LABELS;
export const STOCK_RECEIPT_STATUS_FILTER_OPTIONS = DOCUMENT_STATUS_FILTER_OPTIONS;

export function canPrintStockReceiptLabel(status) {
  return status === 'COMPLETED';
}

export function canEditStockReceipt(status) {
  return status === 'DRAFT';
}

/** SUBMITTED／COMPLETED（及 DRAFT）可進備註專頁；對齊 v1 remark-only 語意。 */
export function canEditStockReceiptRemark(status) {
  return status === 'DRAFT'
    || status === 'SUBMITTED'
    || status === 'COMPLETED';
}

export function canSubmitStockReceipt(status) {
  return status === 'DRAFT';
}

export function canCancelStockReceipt(status) {
  return status === 'DRAFT';
}

export function canApproveStockReceipt(status) {
  return status === 'SUBMITTED';
}

export function canRejectStockReceipt(status) {
  return status === 'SUBMITTED';
}

export function formatStockReceiptStatusLabel(status) {
  return formatDocumentStatusLabel(status);
}
